import type { SVGProps, FC } from "react"

const SvgFinancing: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 18.301 18.301"
    {...props}
  >
    <path
      data-name="Path 108"
      d="M12.406 6.506a5.9 5.9 0 1 0 5.9 5.9 5.9 5.9 0 0 0-5.9-5.9Zm0 5.362a1.6 1.6 0 0 1 .536 3.118v1.171H11.87v-1.171a1.606 1.606 0 0 1-1.072-1.51h1.072a.536.536 0 1 0 .536-.536 1.6 1.6 0 0 1-.536-3.118V8.651h1.072v1.171a1.606 1.606 0 0 1 1.072 1.51h-1.072a.536.536 0 1 0-.536.536Z"
      fill="#333"
    />
    <path
      data-name="Path 109"
      d="M5.969 6.506c3.307 0 5.9-1.413 5.9-3.217S9.276 0 5.969 0 0 1.485 0 3.289s2.662 3.217 5.969 3.217Z"
      fill="#333"
    />
    <path
      data-name="Path 110"
      d="M0 12.066v.874c0 1.8 2.662 3.217 5.969 3.217.188 0 .369-.017.554-.026a6.925 6.925 0 0 1-.9-2.131A8.545 8.545 0 0 1 0 12.066Z"
      fill="#333"
    />
    <path
      data-name="Path 111"
      d="M5.459 12.912c-.012-.169-.026-.337-.026-.509a6.94 6.94 0 0 1 .2-1.621A8.549 8.549 0 0 1 0 8.849v.874c0 1.708 2.4 3.05 5.459 3.189Z"
      fill="#333"
    />
    <path
      data-name="Path 112"
      d="M5.969 9.723a6.994 6.994 0 0 1 1.508-2.25 11.968 11.968 0 0 1-1.508.1A8.721 8.721 0 0 1 0 5.632v.874c0 1.803 2.662 3.217 5.969 3.217Z"
      fill="#333"
    />
  </svg>
)

export default SvgFinancing
